import { selectHoveredOrderDetailsFieldKey } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { selectFocusedOrderDetailsFieldKey } from '../../redux/features/selectors/uiSelectors.ts';
import { setFocusedOrderDetailsFieldKey } from '../../redux/features/uiSlice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';

export const isOrderDetailsFieldAlertHighlighted = (
  fieldName: string,
  focusedOrderDetailsFieldKey?: string,
  hoveredOrderDetailsFieldKey?: string | null,
) =>
  focusedOrderDetailsFieldKey === fieldName || hoveredOrderDetailsFieldKey === fieldName;

export const useOrderDetailsFieldAlertHighlight = (fieldName: string) => {
  const dispatch = useAppDispatch();
  const focusedOrderDetailsFieldKey = useAppSelector(selectFocusedOrderDetailsFieldKey);
  const hoveredOrderDetailsFieldKey = useAppSelector(selectHoveredOrderDetailsFieldKey);
  const isAlertTarget = focusedOrderDetailsFieldKey === fieldName;
  const isAlertHoverTarget = !isAlertTarget && hoveredOrderDetailsFieldKey === fieldName;
  const isAlertHighlighted = isAlertTarget || isAlertHoverTarget;

  const clearAlertTarget = () => {
    if (isAlertTarget) {
      dispatch(setFocusedOrderDetailsFieldKey(undefined));
    }
  };

  return { isAlertTarget, isAlertHighlighted, clearAlertTarget };
};
